import React, {useState, useEffect} from 'react';
import { Layout, Menu, Breadcrumb, Input } from 'antd';
import {Col,Row, Form, Button} from 'react-bootstrap';
import { Segment } from 'semantic-ui-react';
import './Demo.css';
import {formatAlphaStr} from './Common.js';
import SideMenu from './SideMenu';

const { SubMenu } = Menu;
const { Header, Content, Footer, Sider } = Layout;
const { TextArea } = Input;

export default function Tool05() {

    const [sequence, setSequence] = useState("");
    const [result, setResult] = useState([]);

    function handleSequence(e){
        let current = e.target.value;
        // console.log(current);
        setSequence(current)

    }

    function sortId(a, b) {
        return b.value - a.value;
    }

    function handleSubmit(){
        var allStr = formatAlphaStr(sequence);
        var alphaObj = {};
        var objArr = [];
        for (var i = 0; i < allStr.length; i++) {
            key = allStr[i];
            if (alphaObj[key]) {
                alphaObj[key]++; //对象中有这个字母
            } else {
                alphaObj[key] = 1; //对象中没有这个字母,把字母加到对象中
            }
        }

        //遍历这个对象
        for (var key in alphaObj) {
            let item = {
                label: key,
                value: alphaObj[key]
            };
            objArr.push(item);
        }

        objArr.sort(sortId);
        //得到字母频率对象      console.log(objArr);

        //得到字母频率数组
        var result1 = "";
        for (var i = 0; i < objArr.length; i++) {
            result1 += "字母" + objArr[i].label + "出现" + objArr[i].value + "次\n";
        }
        // document.getElementById("demo").innerHTML = result1;
        setResult(result1);
        console.log(objArr);
    }

    return (

        <Layout style={{height: "100vh"}}>
            <Header className="header" style={{minHeight: "5vh"}}>
                <div style={{fontSize:"2rem",color:"white"}}>BioTools</div>
            </Header>
            <Content style={{ padding: '5vh 50px', minHeight: "80vh",maxHeight:"80vh"}}>
            {/* <Breadcrumb style={{ margin: '16px 0' }}>
                <Breadcrumb.Item style={{fontSize:"1.5rem"}}>Tools 01</Breadcrumb.Item>
            </Breadcrumb> */}
            <Layout className="site-layout-background" >
                <Sider className="site-layout-background" width={200}>
                    <SideMenu params={["5"]} />
                </Sider>
                <Content style={{ background:"white", minHeight: "75vh",maxHeight:"75vh" }}>
                    <Segment basic style={{height:"100%"}} >
                        <Segment style={{height:"100%"}} >
                            <Row>
                                <Col sm={1} />
                                <Col>
                                    <Form>
                                        <div style={{height:"1rem"}} />
                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label size="lg">序列</Form.Label>
                                            <TextArea
                                                // value={value}
                                                onChange={handleSequence}
                                                // placeholder="Controlled autosize"
                                                autoSize={{ minRows: 3, maxRows: 5 }}
                                            />
                                            <Form.Text className="text-muted">
                                            序列用空格和换行隔开
                                            </Form.Text>
                                        </Form.Group>

                                        <div style={{height:"1rem"}} />

                                        <Button onClick={handleSubmit}>提交</Button>

                                        <div style={{height:"3rem"}} />

                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label size="lg">结果</Form.Label>
                                            <TextArea
                                                value={result}
                                                // placeholder="Controlled autosize"
                                                autoSize={{ maxRows: 5 }}
                                                // disabled
                                                bordered={false}
                                            />
                                            {/* <div id="demo"></div> */}
                                            
                                            
                                        </Form.Group>
                                        <div style={{height:"1rem"}} />
                                    </Form>
                                </Col>
                                <Col sm={1} />
                            </Row>
                        </Segment>
                    </Segment>
                </Content>
            </Layout>
            </Content>
            <Footer style={{ textAlign: 'center',minHeight: "10vh" }}>TIB ©2021 Created by Biodesign Center</Footer>
        </Layout>
    )
}
